import { Button } from '@/components/atoms/button';

// ============ Types ============

interface MessageTemplate {
  id: string;
  icon: string;
  label: string;
  title: string;
  message: string;
}

interface MessageTemplatesProps {
  onSelect: (title: string, message: string) => void;
}

// ============ Templates ============

const TEMPLATES: MessageTemplate[] = [
  {
    id: 'new',
    icon: '🆕',
    label: 'Nouveauté',
    title: 'Nouvelle collection !',
    message: 'Découvrez notre nouvelle collection, disponible dès maintenant !',
  },
  {
    id: 'promo',
    icon: '🔥',
    label: 'Promo',
    title: 'Offre spéciale',
    message: "Profitez de -20% sur une sélection d'articles. Offre limitée !",
  },
  {
    id: 'restock',
    icon: '📦',
    label: 'Restock',
    title: 'De retour en stock',
    message: 'Les articles que vous aimez sont de nouveau disponibles !',
  },
  {
    id: 'exclusive',
    icon: '🎁',
    label: 'Exclusif',
    title: 'Offre exclusive',
    message: "En tant que client fidèle, profitez d'une offre exclusive !",
  },
];

// ============ Component ============

export function MessageTemplates({ onSelect }: MessageTemplatesProps) {
  return (
    <div className="flex gap-2 flex-wrap">
      {TEMPLATES.map((template) => (
        <Button
          key={template.id}
          variant="outline"
          size="sm"
          type="button"
          onClick={() => onSelect(template.title, template.message)}
          className="text-xs"
        >
          {template.icon} {template.label}
        </Button>
      ))}
    </div>
  );
}

export { TEMPLATES };
